const aboutUsData = {
  companyInfo:{
    contentText:[
      '飞坦数字物流，创始团队拥有十余年中东跨境物流管理经验，原阿里资深产品专家领衔提供技术支持，坚持用科技赋能物流，通过自主研发的数字化管理系统，依托大数据智能解析，实现高危订单拦截，物流路由动态切换，实时跨境回款等增值服务，整合链路优质资源，自营清关渠道，自建中东海外仓，自有本土派送团队，致力干跨境中东的头程物流、进口清关、海处仓、本地配送等全链路服务，为中东跨境商家提供稳定、高效的物流体验，赋能商家掘金中东。'
    ],
    imgList:[
      "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/team1.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=H%2Ft%2FyLSsM4u10Joj1Fd%2BXWg71tc%3D",
      "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/team2.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=aXd22qRW%2By%2F%2BfS3IF%2FiKO%2Bixr7Y%3D",
      "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/team3.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=dDwdbtve8ODHDU%2FYBeZwMqCGE0c%3D",
      "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/team4.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=VExYnitu5OAkbklqtAz4rKboGx4%3D",
      "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/team5.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=c0DHL3hZKpLLC9KI5dYrXiaAQ4k%3D",
      "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/team6.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=NNG1rmGXJni8TyWZfIvtb2srXpw%3D",
      "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/team7.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=fGD6O3dJzWk8LX7yn7WWEEGAaDM%3D",
      "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/team8.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=n3mj6JTvKCjV8cxKMY1l4LONRjs%3D",
      "https://fleetan-hk-bucket.oss-cn-hongkong.aliyuncs.com/Web_fleetan/%E5%AE%98%E7%BD%91%E7%BD%91%E4%B8%8A%E5%AD%98%E5%82%A8%E5%9B%BE%E7%89%87/team9.jpg?OSSAccessKeyId=TMP.3Kjh3WZRSxfPZS395gt6217dXHiqWLksqAC3z3t5fapcrzJujD5Rt8kk45A6ecuAq9jyp2D4Yu1V8YiP748X1uvDcwnszA&Signature=c0oZ%2B46aUPWIl7CueDnB6%2B6chZw%3D",
    ],
    styleList:[
      '客户第一（服务）',
      '团队合作（共赢）',
      '诚实守信（诚信）',
      '拥抱变化（乐观）'
    ],
  },
  courseList:[
    {
      time:'2023-03',
      title:'飞坦正式成为亚马逊SPN服务商',
      content:'',
      url:'',
    },
    {
      time:'2023-01',
      title:'飞坦华南操作中心正式成立',
      content:'',
      url:'',
    },
    {
      time:'2022-11',
      title:'开通阿联酋专线',
      content:'',
      url:'',
    },
    {
      time:'2022-08',
      title:'飞坦正式成为亚马逊自发货VTR授权服务商',
      content:'',
      url:'',
    },
    {
      time:'2022-08',
      title:'飞坦成立两周年',
      content:'',
      url:'',
    },
    {
      time:'2022-07',
      title:'飞坦成为Amazon Seller Flex项目指定合作海外仓之一',
      content:'',
      url:'',
    },
    {
      time:'2022-03',
      title:'海运上线',
      content:'',
      url:'',
    },
    {
      time:'2022-01',
      title:'飞坦海外仓落地沙特',
      content:'',
      url:'',
    },
    {
      time:'2021-03',
      title:'建立义乌办事处',
      content:'',
      url:'',
    },
    {
      time:'2020-08',
      title:'公司成立',
      content:'以助力国货 物畅全球为使命，为跨境电商企业提供全程可视稳定可控的全球一站式物流解决方案以助力国货 物畅全球为使命，为跨境电商企业提供全程可视稳定可控的全球一站式物流解决方案',
      url:'',
    },
  ],
  partnersList:[
    {
      name:'',
      logo:require('@/assets/img/partner/amazon.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/NOON.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/anker.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/fordeal.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/gfs.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/aranex.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/aeAir.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/chinaPost.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/cosco.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/everGreen.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/MAERSK.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/naqel.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/oocl.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/poly.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/railway18.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/SV.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/tomtop.png'),
      url:'',
    },
    {
      name:'',
      logo:require('@/assets/img/partner/uGreen.png'),
      url:'',
    },
  ],
  areaContact:[
    {
      name:'国内业务部',
      contact:'Mandy',
      email:'mandy.shu@dlvd.com',
      phone:'+86-13590412550',
      address:'深圳市龙华区五和大道雅宝路1号星河World D栋6E'
    },
    {
      name:'海外公司',
      contact:'Amin',
      email:'amin@dlvd.com',
      phone:'966531148836',
      address:'Fleetan Digital Logistics, Al Sulay Dist., 14273, Riyadh , Kingdom Of Saudi Arabia'
    }
  ]
}

export default aboutUsData



// WEBPACK FOOTER //
// ./src/view/homePage/content/aboutUs/aboutUsData.js